
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Evaluation, EvaluationFeedback, HighlightedPhrases } from "@/types/evaluation";

export const useEvaluation = (draftId: string | null) => {
  return useQuery({
    queryKey: ["evaluation", draftId],
    queryFn: async () => {
      if (!draftId) return null;
      
      console.log("[Evaluation] Fetching evaluation for draft:", draftId);
      
      const { data, error } = await supabase
        .from("evaluations")
        .select("*")
        .eq("draft_id", draftId)
        .maybeSingle();
      
      if (error) {
        console.error("[Evaluation] Error fetching evaluation:", error);
        return null;
      }

      if (!data) return null;
      
      // Transform the data to match the Evaluation interface with proper type assertions
      const evaluation: Evaluation = {
        overall_score: data.overall_score,
        task_achievement_score: data.task_achievement_score,
        coherence_cohesion_score: data.coherence_cohesion_score,
        lexical_resource_score: data.lexical_resource_score,
        grammatical_range_score: data.grammatical_range_score,
        feedback: data.feedback as unknown as EvaluationFeedback,
        highlighted_phrases: data.highlighted_phrases as unknown as HighlightedPhrases,
      };
      
      console.log("[Evaluation] Transformed evaluation:", evaluation);
      return evaluation;
    },
    enabled: !!draftId,
    retry: 3,
    retryDelay: 1000,
  });
};
